// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logo_logoWrapper__nQ61x","logo":"Logo_logo__OZs6m","scaleLogo":"Logo_scaleLogo__sZKPz","afterLogo":"Logo_afterLogo__D4eIq","showInMenu":"Logo_showInMenu__1t3ke"};